import {
  VideoKeyBoardShortcutProvider,
  VideoProvider as VILVideoProvider,
} from '@statsbomb/video-client-js';
import PropTypes from 'prop-types';
import React from 'react';
import { REACT_APP_VIDEO_SERVICE_URL as VIDEO_SERVICE_URL } from '../../AuthProvider';

export const { REACT_APP_THEO_PLAYER_LICENCE: THEO_PLAYER_LICENCE } =
  process.env;
export function VideoProvider({
  children,
  excludeKeyboardBindings,
  streamsOnly,
}) {
  return (
    <VILVideoProvider
      baseUrlVideoService={VIDEO_SERVICE_URL}
      streamsOnly={streamsOnly}
      theoPlayerLicense={THEO_PLAYER_LICENCE}
    >
      {excludeKeyboardBindings ? (
        children
      ) : (
        <VideoKeyBoardShortcutProvider>
          {children}
        </VideoKeyBoardShortcutProvider>
      )}
    </VILVideoProvider>
  );
}

VideoProvider.propTypes = {
  children: PropTypes.node.isRequired,
  excludeKeyboardBindings: PropTypes.bool,
  streamsOnly: PropTypes.bool,
};
VideoProvider.defaultProps = {
  excludeKeyboardBindings: false,
  streamsOnly: false,
};

export default { VideoProvider };
